<template>
    <div class="mainpage">
        <h2>manufacturing</h2>

        <div class="home">
            <div v-if="!validWorker" class="form">
                <div>Worker:</div>
                <input ref="wrkr" type="text" v-model="wrkr" placeholder="scan Worker QR code" class="inp big"
                       @keypress.enter="validateWorker"/>
            </div>
            <div v-else class="c">
                <div class="flx" @click="invalidateWorker">
                    <refresh-icon/>
                </div>
                Current worker: <b>{{ validWorker }}</b>
            </div>
        </div>
        <div class="home" v-if="validWorker">
            <div class="form">
                <div>Scan SN:</div>
                <input ref="snfld" type="text" v-model="tmpSN" class="inp big" @keypress.enter="scanSN"/>
            </div>
            <div v-if="lastScanProductCountToday!=null" class="msg">Today's production of this item:
                <b v-text="lastScanProductCountToday"></b> serials.
            </div>
        </div>
        <div class="home" v-if="sns.length">
            <div class="flx" @click="clear_sns">
                <del-icon/>
            </div>
            <h4>Scanned S/N in this batch:</h4>
            <ul class="snlist">
                <li v-for="sn in sns.slice().reverse()"
                    :class="{ 'notfound': snChecked[sn]&&snChecked[sn].status == 0,
                                'ok': snChecked[sn]&&snChecked[sn].status == 1,
                                'dupl': snChecked[sn]&&snChecked[sn].status >= 2
                    }"><span class="sn" v-text="(snChecked[sn]&&snChecked[sn].validSN?snChecked[sn].validSN:sn)"></span>
                    <span class="ponum" v-text="(snChecked[sn]&&snChecked[sn].poNum?snChecked[sn].poNum:'')"></span>
                    <span class="ponum" v-text="(snChecked[sn]&&snChecked[sn].iC?snChecked[sn].iC:'')"></span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    //K18-07730
    import Vue from 'vue'
    import debounce from '@/debounce';
    import {mapState} from 'vuex'
    import RefreshIcon from "vue-material-design-icons/refresh"
    import DelIcon from "vue-material-design-icons/delete-circle"


    export default {
        name: "Production",
        components: {
            RefreshIcon, DelIcon
        },
        computed: {
            ...mapState(['snChecked', 'validWorker', 'lastScanProductCountToday']),
        },
        data() {
            return {
                wrkr: '',
                tmpSN: '',
                sns: []
            }
        },
        mounted() {
            if (this.validWorker) {
                if (this.$refs.snfld) this.$refs.snfld.focus();
            } else {
                if (this.$refs.wrkr) this.$refs.wrkr.focus();
            }
        },
        methods: {
            clear_sns: function () {
                this.sns = [];
            },
            scanSN: function () {
                if (this.tmpSN.trim().length < 5) return;
                this.sns.push(this.tmpSN.trim());
                this.$store.dispatch('validateSN', {'sn': this.tmpSN, 'worker': this.validWorker});
                this.tmpSN = '';
            },
            invalidateWorker: function () {
                this.$store.commit('saveWorker', '');
                var self = this;
                Vue.nextTick(function () {
                    self.$refs.wrkr.select();
                })

            },
            validateWorker: function () {
                if (this.wrkr)
                    this.$store.commit('saveWorker', this.wrkr);
                var self = this;

                Vue.nextTick(function () {
                    if (self.$refs.snfld) self.$refs.snfld.focus();
                })
            }
        }
    }
</script>

<style scoped>
    .form > DIV { margin: 5px 7px 5px 0;   }

    .msg { text-align: center }

    h4 {
        margin: 0
    }

    .form {
        display: flex;
        clear: both;
        align-items: center;
    }

    .form > DIV {
        white-space: nowrap
    }

    .flx {
        float: right;
        font-size: 20px;
        margin: -5px 5px;
    }

    .snlist {
        padding: 0;
        margin: 10px 0;
        list-style-type: none
    }

    .snlist LI {
        margin: 0px;
        padding: 2px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: solid 1px #ccc
    }

    .snlist .sn {
        flex: 1 1;
        padding-right: 4px
    }

    .snlist li:before {
        content: '?';
        padding: 1px 6px;
        color: white;
        background-color: deepskyblue;
        margin-right: 6px;
        border-radius: 4px;
    }

    .snlist li.ok:before {
        content: '✓';
        padding: 1px 5px;
        background-color: green;
    }

    .snlist li.notfound:before {
        content: '⨉';
        font-weight: bold;
        padding: 1px 6px;
        background-color: red;
        line-height: 17px;
    }

    .snlist li.dupl:before {
        content: '‼';
        font-weight: bold;
        padding: 1px 6px;
        background-color: orange;
    }

    .ponum {
        border-left: solid 2px #999;
        padding: 0 2px;
        flex: 1 1;
        text-align: center
    }
</style>